import { useTranslation } from "react-i18next";

const PayingGuide = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 py-6">
      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "1" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step1")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-1.png"}
        alt="Step 1"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "2" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step2")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-2.png"}
        alt="Step 2"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "3" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step3")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-3.png"}
        alt="Step 3"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "4" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step4")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-4.png"}
        alt="Step 4"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "5" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step5")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-5.png"}
        alt="Step 5"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "6" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step6")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-6.png"}
        alt="Step 6"
        className="w-full"
      />

      <p>
        <span className="text-primary-blue font-bold">
          {" "}
          {t("instructions.step", { number: "7" })}:{" "}
        </span>
        {t("instructions.instructions_list.paying_guide.content.step7")}
      </p>
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-7.png"}
        alt="Step 7"
        className="w-full"
      />
      <img
        src={"https://evisa.gov.vn/assets/e-visa/hdsd/en/hdsd-4-8.png"}
        alt="Step 7"
        className="w-full"
      />
    </div>
  );
};

export default PayingGuide;
